import router from './tasks.router'

export default { router }
